<template>
    <v-menu  open-on-hover close-on-click close-on-content-click offset-y rounded style="z-index: 999">
        <template v-slot:activator="{ on, attrs }">
            <v-btn class="font-weight-bold" text x-large color="primary" v-bind="attrs" v-on="on">
                {{ currentWebAppName }}
            </v-btn>
        </template> 
        <v-list>
            <v-list-item-group v-model="selectedApp">
                <v-list-item v-for="(item, index) in webAppNames" :key="index">
                    <v-list-item-title>{{ item }}</v-list-item-title>
                </v-list-item>
            </v-list-item-group>            
        </v-list>
    </v-menu>          
</template>

<script>
    import { mapGetters, mapActions } from 'vuex'

    export default {
        name: 'WebAppSelection',
        mounted: function () {
            for (let i=0; i < this.webAppNames.length; i++) {
                if (this.webAppNames[i] == this.currentWebAppName) {
                    this.selectedApp = i
                    break;
                }
            }
        },
        computed: {
            ...mapGetters([
                'webAppNames',
                'currentWebAppName',
            ])
        },
        watch: {
            selectedApp: function(newValue, oldValue) {
                this.setCurrentWebAppName(this.webAppNames[newValue])
            }
        },        
        methods: {
            ...mapActions([
                'setCurrentWebAppName'
            ]),      
        },
        data: function() {
            return {
                selectedApp: -1
            }
        },
    }

</script>

<style scoped lang="scss">

</style>
